import { FC } from "react";
import { ColumnDef } from "@tanstack/react-table";
import { Table } from "@/shared/ui/table";
import { PhoneWhitelistDTO } from "@/shared/api/phone-whitelist";
import { ActionButton } from "@/shared/ui/action-button";
import DeleteSvg from "@/shared/assets/images/Trash.svg";
import { Loader } from "@/shared/ui/loader";
import { NoTableData } from "@/shared/ui/no-table-data";

interface PhoneWhitelistTableProps {
    phones: PhoneWhitelistDTO[];
    isLoading: boolean;
    onDelete: (id: string) => void;
}

export const PhoneWhitelistTable: FC<PhoneWhitelistTableProps> = ({ phones, isLoading, onDelete }) => {
    const columns: ColumnDef<PhoneWhitelistDTO, any>[] = [
        {
            accessorFn: (phone) => (
                <div className="text-[13px] text-color-dark font-semibold">
                    {phone.phone}
                </div>
            ),
            id: 'phone',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Телефон</div>,
        },
        {
            accessorFn: (phone) => (
                <div className="text-[13px] text-color-dark font-semibold">
                    {new Date(phone.created_at).toLocaleString('ru-RU')}
                </div>
            ),
            id: 'created_at',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Дата добавления</div>,
        },
        {
            accessorFn: (phone) => (
                <div className="w-full flex justify-end">
                    <ActionButton
                        onClick={() => onDelete(phone.id)}
                        icon={DeleteSvg}
                    />
                </div>
            ),
            id: 'actions',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div />,
        },
    ];

    return (
        <>
            {Boolean(phones.length) && (
                <div className="table_box">
                    <Table columns={columns} data={phones} />
                </div>
            )}
            {(!Boolean(phones.length) && isLoading) && (
                <div className="info_panel">
                    <Loader />
                </div>
            )}
            {(!Boolean(phones.length) && !isLoading) && (
                <NoTableData label="Нет данных о телефонах в белом списке" />
            )}
        </>
    );
};

